/* eslint-disable sort-keys-fix/sort-keys-fix, typescript-sort-keys/interface, camelcase */
/*
 * This code is generated by ../../../scripts/generateSchemas.ts.
 * Do not adapt manually. Instead run 'yarn generate'.
 *
 * Source: ../../types/ai-first-coding-exercise/v0.ts
 */

import { createValidator } from '../../helpers/validator';
export const AiFirstCodingExerciseV0Schema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    aiContext: {
      type: 'string',
      title: 'AI Context',
      description: 'Additional context passed to the AI prompt. For example, pass the schema of a SQL table used in the exercise.'
    },
    promptHint: {
      type: 'string',
      title: 'AI Prompt Hint',
      description: 'A hint that is shown in the AI Prompt Area to help the learner write the prompt.'
    },
    promptHintInstructions: {
      type: 'string',
      title: 'AI Prompt Hint Instructions',
      description: 'Instructions that are shown when the learner has used the Prompt Hint.',
      default: "We've provided an incomplete prompt in the prompting area. Fill in the `___` to complete it and then submit your prompt"
    },
    promptPlaceholderText: {
      type: 'string',
      title: 'AI Prompt Placeholder Text',
      description: 'Placeholder text for the AI Prompt Area.',
      maxLength: 80,
      default: 'Tell our AI what to do, e.g. "Add comments to better explain the code"'
    },
    promptSolution: {
      type: 'string',
      title: 'AI Prompt Solution',
      description: 'The solution to the AI Prompt.'
    },
    solutionInstructions: {
      type: 'string',
      title: 'AI Prompt Solution Instructions',
      description: 'Instructions that are shown when the learner has requested the solution for the prompt telling the user what we have done.'
    },
    title: {
      type: 'string'
    },
    xp: {
      type: 'number'
    },
    course_id: {
      type: 'number'
    },
    chapter_id: {
      type: 'number'
    },
    language: {
      type: 'string',
      enum: ['r', 'python', 'revo', 'sql', 'shell', 'scala', 'julia', 'containers']
    },
    runtime_config: {
      type: 'string'
    },
    assignment: {
      type: 'string'
    },
    sample_code: {
      type: 'string',
      default: ''
    },
    instructions: {
      type: ['string', 'null'],
      default: null
    },
    sct: {
      type: 'string',
      default: ''
    },
    pre_exercise_code: {
      type: 'string',
      default: ''
    },
    solution: {
      type: 'string',
      default: ''
    }
  },
  required: ['assignment', 'chapter_id', 'course_id', 'instructions', 'language', 'pre_exercise_code', 'promptHint', 'promptHintInstructions', 'promptPlaceholderText', 'promptSolution', 'sample_code', 'sct', 'solution', 'solutionInstructions', 'title', 'xp'],
  definitions: {}
};
export const isValidAiFirstCodingExerciseV0 = createValidator(AiFirstCodingExerciseV0Schema);
export const AiFirstCodingExerciseV0Definition = {
  schema: AiFirstCodingExerciseV0Schema,
  validate: isValidAiFirstCodingExerciseV0
};